import React, { Dispatch, SetStateAction } from 'react';
import styled, { css } from 'styled-components';

interface TabProps {
  selected: string;
  setSelected: Dispatch<SetStateAction<string>> | ((val: string) => void);
  tabItems: { key: string; text: string }[];
  style?: React.CSSProperties;
}

const TabItem = styled.div<{ enabled?: boolean }>`
  cursor: pointer;
  width: 100%;
  padding: 1rem;
  text-align: center;

  font-weight: 600;
  border-bottom: 2px solid ${({ theme, enabled }) => (enabled ? theme.primary : theme.white)};

  ${({ enabled }) =>
    enabled &&
    css`
      color: ${({ theme }) => theme.primary};
    `}
`;

const TabWrapper = styled.div<{ tabItemCount: number }>`
  width: 100%;
  /* padding: 1rem 0; */
  display: grid;
  grid-template-columns: ${({ tabItemCount }) => `repeat(${tabItemCount}, 1fr)`};
`;

const Tab = ({ selected, setSelected, tabItems, style }: TabProps) => {
  return (
    <TabWrapper tabItemCount={tabItems.length} style={style}>
      {tabItems.map((tab) => (
        <TabItem enabled={tab.key === selected} onClick={() => setSelected(tab.key)}>
          {tab.text}
        </TabItem>
      ))}
    </TabWrapper>
  );
};

export default Tab;

export const TabList = styled.div`
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  /* margin: 10px 0; */
  width: 100%;
  border-bottom: solid 1px #ccc;
`;

export const TabButton = styled.button<{ selected?: boolean }>`
  padding: 0 1rem;
  height: 60px;
  font-size: 1rem;
  font-weight: 600;
  background-color: transparent;
  border: none;
  color: ${(props) => (props.selected ? '#222' : '#A9AFC0')};
  border-bottom: solid 2px ${({ selected, theme }) => (selected ? theme.main[600] : '#fff')};
`;
